// extracted by mini-css-extract-plugin
module.exports = {"noResult":"style_noResult__xdv4I","title":"style_title__CtkK5","requestItBtn":"style_requestItBtn__t2_MY"};